__turbopack_context__.v({
  "desktop-only": "AImage-module__Uhr7Tq__desktop-only",
  "fill": "AImage-module__Uhr7Tq__fill",
  "image": "AImage-module__Uhr7Tq__image",
  "mobile-only": "AImage-module__Uhr7Tq__mobile-only",
});
